<template>
  <accounts-status-alert
    :isTestAccount="true"
    :title="$t('title')"
    :message="$t('description')"
  />
</template>
<script>
export default {
  name: 'TestAccountStatusAlert',
  components: {
    AccountsStatusAlert: () =>
      import(
        /* webpackChunkName: "AccountsStatusAlertContainer" */ '@/components/project/globals/AccountsStatusAlert/AccountsStatusAlertContainer.vue'
      )
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Loja de teste",
      "description":"As vendas em Loja de teste são simulações e não geram pagamentos reais.",
      "help-url": "https://pagarme.helpjuice.com/p2-manual-da-dashboard/dashboard-criando-uma-conta-de-teste?from_search=174193836",
      "learn-more": "Entenda mais"
    },
    "en-US": {
      "title": "Test environment",
      "description":"The operations you perform are just simulations, and do not create real payments.",
      "help-url": "https://pagarme.helpjuice.com/p2-manual-da-dashboard/dashboard-criando-uma-conta-de-teste?from_search=174193836",
      "learn-more": "Learn more"
    }
  }
</i18n>
